// import { useEffect } from 'react'
import { Space } from 'antd'
import { LightThemeProvider } from '@qflow/theme'

import { Meters } from 'portal/components/Utilities'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'

export const MetersPage = () => {
  return (
    <PageContainer id="Meters" style={{ paddingBottom: '0' }}>
      <LightThemeProvider>
        <Sidebar />
        <Space direction="vertical" size="middle">
          <Meters />
        </Space>
      </LightThemeProvider>
    </PageContainer>
  )
}
